// extracted by mini-css-extract-plugin
export default {"Empty":"FSnE3wu7qWZd1FipkpYg"};